/* ============================================================
   LuXe — web app installable (PWA)
   - bouton « Installer l'app » : vraie invite sur Chrome / Edge / Android,
     mode d'emploi sur iPhone / iPad (Safari) et sur Mac
   - petite bannière une seule fois sur mobile
   - dans l'app : bouton retour (pas de barre de navigateur)
   ============================================================ */
(function () {
  var html = document.documentElement;
  var ua = navigator.userAgent;
  // ouverte depuis l'icône : start_url du manifeste = /?app=1, retenu pour toute la session
  try { if (/[?&]app=1(&|$)/.test(location.search)) sessionStorage.setItem("luxe-dans-app", "1"); } catch (e) {}
  var estApp = ["standalone", "fullscreen", "minimal-ui", "window-controls-overlay"].some(function (m) {
      return window.matchMedia("(display-mode: " + m + ")").matches;
    }) || navigator.standalone === true || (function () { try { return !!sessionStorage.getItem("luxe-dans-app"); } catch (e) { return false; } })();
  // navigateur intégré d'une appli (Instagram, TikTok, Facebook, Snapchat…) : installation impossible
  var dansUneAppli = /Instagram|FBAN|FBAV|FB_IAB|musical_ly|BytedanceWebview|TikTok|Snapchat|Line\/|Twitter|LinkedInApp|Pinterest|; wv\)/i.test(ua);
  var ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  var mac = !ios && /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|Edg|Firefox/.test(ua);
  var mobile = window.matchMedia("(max-width: 760px)").matches;
  var icone = (window.LUXE && window.LUXE.appIcone) || "";
  var invite = null;

  function lire(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function bloquee() { var v = lire("luxe-app-3"); return v === "refusee" || v === "installee"; }
  function ecrire(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- déjà dans l'app ---------- */
  if (estApp) {
    html.classList.add("est-app");
    ecrire("luxe-app-3", "installee");
    var accueil = /^\/([a-z]{2}(-[a-z]{2})?\/?)?$/i.test(location.pathname);
    if (!accueil) {
      var retour = document.createElement("button");
      retour.type = "button";
      retour.className = "app-retour";
      retour.setAttribute("aria-label", "Retour");
      retour.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      retour.addEventListener("click", function () {
        if (history.length > 1) history.back(); else location.href = "/";
      });
      document.body.appendChild(retour);
    }
    return;
  }

  // dans Instagram / TikTok… : ni bouton ni fenêtre, ça ne servirait à rien
  if (dansUneAppli) return;

  /* ---------- boutons d'installation ---------- */
  var boutons = [].slice.call(document.querySelectorAll("[data-app-install]"));
  function montrer() { boutons.forEach(function (b) { b.hidden = false; }); }
  function cacher() {
    boutons.forEach(function (b) { b.hidden = true; });
    var t = document.querySelector(".app-toast"); if (t) t.remove();
  }

  // Firefox sur PC ne sait pas installer une app : rien à proposer
  if (/Firefox/.test(ua) && !/Android/.test(ua)) return;
  // Chrome / Edge / Samsung (PC et Android) installent en un clic : bouton et fenêtre
  // n'apparaissent qu'à leur feu vert, et le clic lance TOUJOURS l'installation directe.
  // Safari (iPhone / Mac) ne sait pas : on y garde le mode d'emploi.
  var installDirecte = "onbeforeinstallprompt" in window;
  if (!installDirecte) montrer();
  window.addEventListener("beforeinstallprompt", function (e) {
    e.preventDefault();
    invite = e;
    // le navigateur propose l'installation → l'app n'est pas (ou plus) installée
    if (lire("luxe-app-3") === "installee") { try { localStorage.removeItem("luxe-app-3"); } catch (x) {} }
    montrer();
    proposer();
    // fenêtre déjà ouverte en attente (Android) : le bouton devient actif
    var ok = document.querySelector(".app-toast [data-ok]");
    if (ok) { ok.disabled = false; ok.textContent = "Installer maintenant"; }
  });
  window.addEventListener("appinstalled", function () { invite = null; ecrire("luxe-app-3", "installee"); cacher(); });

  function installer() {
    if (invite) {
      invite.prompt();
      invite.userChoice.then(function (r) { if (r.outcome === "accepted") cacher(); invite = null; });
      return;
    }
    if (!installDirecte) aide();
  }
  boutons.forEach(function (b) { b.addEventListener("click", installer); });

  /* ---------- mode d'emploi (iPhone, Mac, autres navigateurs) ---------- */
  var partage = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3v12M8 7l4-4 4 4M6 11H5v10h14V11h-1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function aide() {
    var etapes;
    if (ios) etapes = [
      "Touche le bouton <b>Partager</b> " + partage + " de Safari.",
      "Choisis <b>Sur l’écran d’accueil</b>, puis <b>Ajouter</b>.",
      "L’icône <b>LuXe</b> apparaît avec tes apps."
    ];
    else if (mac) etapes = [
      "Dans la barre de menus de Safari, ouvre <b>Fichier</b>.",
      "Choisis <b>Ajouter au Dock</b>, puis <b>Ajouter</b>.",
      "LuXe s’ouvre ensuite comme une app, depuis le Dock."
    ];
    else if (/Android/.test(ua)) etapes = [
      "Touche le menu <b>⋮</b> en haut à droite du navigateur.",
      "Choisis <b>Installer l’application</b> (ou <b>Ajouter à l’écran d’accueil</b>).",
      "L’icône <b>LuXe</b> apparaît avec tes apps."
    ];
    else etapes = [
      "Clique sur l’icône <b>Installer</b> ⊕ à droite de la barre d’adresse,",
      "ou ouvre le menu <b>⋯</b> du navigateur → <b>Applications</b> → <b>Installer LuXe</b>.",
      "LuXe s’ouvre ensuite dans sa propre fenêtre, comme une app."
    ];
    var d = document.createElement("dialog");
    d.className = "app-aide";
    d.setAttribute("aria-labelledby", "app-aide-titre");
    d.innerHTML =
      '<img src="' + icone + '" alt="" width="64" height="64">' +
      '<h3 id="app-aide-titre">Installer <span class="notranslate" translate="no">LuXe</span></h3>' +
      "<ol>" + etapes.map(function (t) { return "<li>" + t + "</li>"; }).join("") + "</ol>" +
      '<button type="button" class="btn">Compris</button>';
    document.body.appendChild(d);
    d.querySelector("button").addEventListener("click", function () { d.close(); });
    d.addEventListener("close", function () { d.remove(); });
    d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
    d.showModal();
  }

  /* ---------- fenêtre en bas de l'écran : une version téléphone, une version PC ----------
     - croix : on ne la remontre plus jamais (luxe-app = "refusee")
     - Installer : installation directe (Chrome, Edge, Samsung) ; sur iPhone, Apple
       ne le permet pas → on montre les 2 gestes
     - ignorée : elle revient à la prochaine visite (une fois par visite) */
  var depart = Date.now();
  function proposer() {
    if (bloquee() || document.querySelector(".app-toast")) return;
    try { if (sessionStorage.getItem("luxe-app-vue-3")) return; } catch (e) {}
    setTimeout(function () {
      if (bloquee() || document.querySelector(".app-toast")) return;
      try { sessionStorage.setItem("luxe-app-vue-3", "1"); } catch (e) {}
      var luxe = '<span class="notranslate" translate="no">LuXe</span>';
      var t = document.createElement("div");
      t.className = "app-toast " + (mobile ? "tel" : "pc");
      t.setAttribute("role", "dialog");
      t.setAttribute("aria-label", "Installer l'app LuXe");
      t.innerHTML = mobile
        ? '<button type="button" class="app-toast-x" aria-label="Fermer et ne plus proposer">×</button>' +
          '<div class="app-toast-tete"><img src="' + icone + '" alt="" width="52" height="52">' +
          "<div><b>L’app " + luxe + " sur ton téléphone</b><small>Une icône sur ton écran d’accueil, la boutique en plein écran.</small></div></div>" +
          '<button type="button" class="btn primary" data-ok>' + (invite ? "Installer l’app" : "Ajouter à l’écran d’accueil") + "</button>"
        : '<img src="' + icone + '" alt="" width="56" height="56">' +
          "<div><b>Installe " + luxe + " sur ton PC</b><small>Ouvre la boutique dans sa propre fenêtre, depuis ton bureau.</small>" +
          '<button type="button" class="btn primary sm" data-ok>Installer sur mon PC</button></div>' +
          '<button type="button" class="app-toast-x" aria-label="Fermer et ne plus proposer">×</button>';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add("on"); });
      function fermer() { t.classList.remove("on"); setTimeout(function () { t.remove(); }, 450); }
      var ok = t.querySelector("[data-ok]");
      ok.addEventListener("click", function () {
        // Android : Chrome n'est pas encore prêt (il attend ~30 s et un appui) → on patiente
        if (installDirecte && !invite) { ok.disabled = true; ok.textContent = "Un instant…"; return; }
        fermer(); installer();
      });
      t.querySelector(".app-toast-x").addEventListener("click", function () { ecrire("luxe-app-3", "refusee"); fermer(); });
    }, Math.max(0, 2000 - (Date.now() - depart)));
  }
  // navigateurs sans installation directe (Safari iPhone / Mac, Firefox Android) : mode d'emploi
  // Android : la fenêtre vient tout de suite, sans attendre le feu vert de Chrome
  if (!installDirecte || /Android/.test(ua)) proposer();
})();
